import { Box, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { FormattedMessage, useIntl } from 'react-intl';
import { inject, observer } from 'mobx-react';
import Service from 'src/services/api/Api';
import UserStore from 'src/stores/UserStore';

const ListItemLink = ({ key, onClick, label }: { key: string; onClick: () => void; label: string }) => (
    <ListItem key={key} button onClick={onClick} sx={{ pl: 0 }}>
        <ListItemIcon sx={{ minWidth: 24 }}>
            <ArrowForward />
        </ListItemIcon>
        <ListItemText primary={label} />
    </ListItem>
);

interface KnowledgeInfoProps {
    user?: typeof UserStore.Type;
}

const KnowledgeInfoBrekr = inject('user')(
    observer(({ user }: KnowledgeInfoProps) => {
        const intl = useIntl();

        const getKnowledgeBaseUrl = async () => {
            const language = user?.preferredLang || 'nl-NL';
            try {
                const res = await Service.getKnowledgeBaseUrl(
                    // No English version of the knowledge base for Brekr, yet
                    language.toLowerCase().startsWith('en') ? 'nl-NL' : language,
                );
                if (res.data) {
                    window.open(res.data, '_blank');
                }
            } catch (e) {
                console.error(e);
            }
        };

        const generalResources = [
            {
                label: 'menu.knowledgeBase.description',
                onClick: () => getKnowledgeBaseUrl(),
            },
            {
                label: 'knownledgeBase.dealerFootage',
                onClick: () => {
                    window.open(
                        'https://kpn1296187.sharepoint.com/:f:/s/BREKRKnowledgeBase/IgCSmpIYKPHvSLvoPRnKXgouAQzCXLGmCNiuGFmFQmyqx54?e=JlaBAh',
                        '_blank',
                    );
                },
            },
            {
                label: 'knownledgeBase.codesProducts',
                onClick: () => {
                    window.open(
                        'https://kpn1296187.sharepoint.com/:f:/s/BREKRKnowledgeBase/IgBhQYcUZ2t7S7NCZMFvOa1sARyDLMWnNzvTRlV-hH3oStU?e=v6E6c8',
                        '_blank',
                    );
                },
            },
        ];

        const f250Resources = [
            {
                label: 'knownledgeBase.serviceManuals',
                onClick: () => {
                    window.open(
                        'https://kpn1296187.sharepoint.com/:f:/s/BREKRKnowledgeBase/IgCgRPOpD0ZWQ7AaVGxlWWTTARE4aVAuaR7qQAroAwJCwWg?e=iluMSe',
                        '_blank',
                    );
                },
            },
        ];

        const b4000Resources = [
            {
                label: 'knownledgeBase.serviceManuals',
                onClick: () => {
                    window.open(
                        'https://kpn1296187.sharepoint.com/:f:/s/BREKRKnowledgeBase/IgBrqYKfscRNSYQmGTohAhmqAaGwhcHi_rtopkUQLGAmqvI?e=c8okTA',
                        '_blank',
                    );
                },
            },
        ];

        return (
            <Box>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    <FormattedMessage id="menu.knowledge" />
                </Typography>

                {/* General Section */}
                <Box sx={{ mb: 4 }}>
                    <Typography sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                        <FormattedMessage id="knownledgeBase.general" />
                    </Typography>
                    <List>
                        {generalResources.map((resource, index) => (
                            <ListItemLink
                                key={index.toString()}
                                onClick={resource.onClick}
                                label={intl.formatMessage({ id: resource.label })}
                            />
                        ))}
                    </List>
                </Box>

                {/* F250 Section */}
                <Box sx={{ mb: 4 }}>
                    <Typography sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>F250</Typography>
                    <List>
                        {f250Resources.map((resource, index) => (
                            <ListItemLink
                                key={index.toString()}
                                onClick={resource.onClick}
                                label={intl.formatMessage({ id: resource.label })}
                            />
                        ))}
                    </List>
                </Box>

                {/* B4000 Section */}
                <Box sx={{ mb: 4 }}>
                    <Typography sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>B4000</Typography>
                    <List>
                        {b4000Resources.map((resource, index) => (
                            <ListItemLink
                                key={index.toString()}
                                onClick={resource.onClick}
                                label={intl.formatMessage({ id: resource.label })}
                            />
                        ))}
                    </List>
                </Box>
            </Box>
        );
    }),
);

export default KnowledgeInfoBrekr;